<template>
  <modal
    ref="addMeasuring"
    :ok-disabled="loading"
    :ok-title="!id ? 'Pridať' : 'Upraviť'"
    :title="!id ? 'Pridať meranie' : 'Upraviť meranie'"
    cancel-title="Zrušiť"
    full-height
    name="add-measuring"
    scrollable
    size="md"
    type="from-right"
    @hidden="Object.assign($data, $options.data())"
    @ok="save"
    @show="fetchData"
  >
    <b-overlay :blur="null" :show="loading" class="h-100" opacity="0">
      <transition mode="out-in" name="fadeShort">
        <div v-if="!loading" ref="scroll" v-bar>
          <div>
            <b-form-group
              label-cols-sm="5"
              label="Poč. stav"
              label-for="startValue"
            >
              <vue-autonumeric
                v-model="form.startValue"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('startValue') }"
                class="form-control"
                data-vv-as="Poč. stav"
                name="startValue"
              />
              <b-form-invalid-feedback>
                {{ errors.first('startValue') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Kon. stav"
              label-for="endValue"
            >
              <vue-autonumeric
                v-model="form.endValue"
                v-validate="`required|min_value:${form.startValue}`"
                :class="{ 'is-invalid': errors.has('endValue') }"
                class="form-control"
                data-vv-as="Kon. stav"
                name="endValue"
              />
              <b-form-invalid-feedback>
                {{ errors.first('endValue') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Spotreba"
              label-cols-sm="5"
              label-for="consumption"
            >
              <vue-autonumeric
                v-validate="'required'"
                :value="sumConsumption"
                :class="{ 'is-invalid': errors.has('consumption') }"
                class="form-control"
                data-vv-as="Spotreba"
                name="consumption"
              />
              <b-form-invalid-feedback>
                {{ errors.first('consumption') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-cols-sm="5" label="MJ" label-for="unit">
              <b-form-input
                v-model="form.unit"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('unit') }"
                data-vv-as="MJ"
                name="unit"
              />
              <b-form-invalid-feedback>
                {{ errors.first('unit') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Od" label-cols-sm="5" label-for="periodFrom">
              <single-date
                v-model="form.periodFrom"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('periodFrom') }"
                data-vv-as="Od"
                name="periodFrom"
                disabled
              />
              <b-form-invalid-feedback>
                {{ errors.first('periodFrom') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Do" label-cols-sm="5" label-for="periodTo">
              <single-date
                v-model="form.periodTo"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('periodTo') }"
                data-vv-as="Do"
                name="periodTo"
                disabled
              />
              <b-form-invalid-feedback>
                {{ errors.first('periodTo') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Predch. spotreba"
              label-for="previuousConsumption"
            >
              <vue-autonumeric
                v-model="form.previuousConsumption"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('previuousConsumption') }"
                class="form-control"
                data-vv-as="Predch. spotreba"
                name="previuousConsumption"
              />
              <b-form-invalid-feedback>
                {{ errors.first('previuousConsumption') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label-cols-sm="5"
              label="Porov. koef."
              label-for="compareCoefficient"
            >
              <vue-autonumeric
                v-model="form.compareCoefficient"
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('compareCoefficient') }"
                class="form-control"
                data-vv-as="Porov. koef."
                name="compareCoefficient"
              />
              <b-form-invalid-feedback>
                {{ errors.first('compareCoefficient') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </transition>
    </b-overlay>
  </modal>
</template>
<script>
import Modal from '@/components/Modal'
import SingleDate from '@/components/inputs/SingleDate'
import operationService from '@/services/api/operationService'

export default {
  components: {
    Modal,
    SingleDate,
  },
  data() {
    return {
      loading: false,
      id: null,
      form: {},
    }
  },
  computed: {
    sumConsumption() {
      return this.form.endValue - this.form.startValue
    },
  },
  methods: {
    fetchData() {
      if (this.id) {
        this.loading = true
        operationService.getDeviceData(this.id).then((res) => {
          this.form = res.data
          this.loading = false
        })
      }
    },
    save(e) {
      e.preventDefault()
      this.$validator.validateAll().then(() => {
        if (!this.errors.any() && !this.loading) {
          if (this.id) {
            operationService
              .updateDeviceData(this.id, this.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Meranie bolo upravené',
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-measuring')
                this.$root.$emit('operation.reloadMeasurerData')
              })
          } else {
            operationService.createDeviceData(this.form).then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              }).catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba',
                  timer: 5000,
                })
              })
              this.$root.$emit('modal-hide', 'add-measuring')
              this.$root.$emit('operation.reloadMeasurerData')
            })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
